import React from "react";

export type AssetsContextValue = {
  formattedBalance?: string;
  fancyBearsInWallet?: [tokenId: number, isClaimed: boolean][];
  fancyBearsInWalletCount?: number;
  readFancyBearsClaimStatusByAddress: () => void;
  honeyJarsInWallet?: number[];
  honeyJarsInWalletCount?: number;
  readHoneyJarsInWallet: () => void;
  goldlistClaimedCount?: number;
  goldlistMaxClaim?: number;
  readGoldlistClaimedCount: () => void;
};

const AssetsContext = React.createContext<AssetsContextValue>({
  formattedBalance: undefined,
  fancyBearsInWallet: undefined,
  fancyBearsInWalletCount: undefined,
  readFancyBearsClaimStatusByAddress: () => {},
  honeyJarsInWallet: undefined,
  honeyJarsInWalletCount: undefined,
  readHoneyJarsInWallet: () => {},
  goldlistClaimedCount: undefined,
  goldlistMaxClaim: undefined,
  readGoldlistClaimedCount: () => {},
});

export default AssetsContext;
